import token, { tokenToVars } from '../token';
import Slider from './slider';

export { Slider };
export default tokenToVars(Slider, token);
